import ScreenComponent from "../../components/screenComponent";
import screens from "../../screens";
import {withRouter} from "react-router-dom";
import React from "react";
import MyCard from "../../components/myCard";
import loadParameters from "../../components/loadParameters";
import {Get, Post} from "../../components/request";
import {isObject} from "lodash";
import DonneesIDM from "../../forms/donneesIDM";

class IDM extends ScreenComponent {

    constructor(props) {
        super(props);
        this.state = {
            memoire: {},
            disabled: false,
            validateForm: false,
            disabledIDM: false,
        };

        this.state.parameters = [];
        this.state.parameters["SessionID"] = [];
        this.state.parameters["SessionAAActiveID"] = [];
        this.state.parameters["LangueMemoireID"] = [];
        this.state.parameters["MembrePersonnelID"] = [];
        this.state.parameters["LangueDefenseID"] = [];
        this.state.parameters["StatutConfidentialiteID"] = [];
    }

    async componentDidMount() {
        super.componentDidMount();

        await loadParameters(this, "MembrePersonnelID,LangueMemoireID,SessionAAActiveID,SessionID,LangueDefenseID,StatutConfidentialiteID");
        this.state.parameters.StatutConfidentialiteAffichageID = this.state.parameters.StatutConfidentialiteID.filter(f => !f.label.includes("Confidentialité acceptée"));

        let {body} = await Get(`/v1/extranet/student/${screens.Memoire}`);

        this.setState({
            memoire: body,
        });
    }

    async save(data) {
        data["MemoireID"] = this.state.memoire.MemoireID;
        data["MembrePersonnelID"] = this.state.memoire.MembrePersonnelID;
        data["MemoireTitre"] = this.state.memoire.MemoireTitre;

        Object.entries(data).forEach(([key, value]) => {
            if (isObject(value)) data[key] = value.value
        });

        await Post(`/v1/extranet/student/IDM`, data, "Sauvegarde en cours..", {render: "IDM sauvegardé !"}, {render: "Erreur lors de la sauvegarde"});

        this.componentDidMount();
        this.props.history.push(process.env.APP_ROOT + 'memoire');
    }


    render() {
        return (
            <>
                <section>
                                <MyCard header={"Informations relatives à la Défense du Mémoire (IDM)"}
                                        body={
                                            <DonneesIDM onSubmit={this.save.bind(this)}
                                                        parameters={this.state.parameters}/>}/>
                </section>
            </>
        );
    }
}
export default withRouter(IDM);